export default __webpack_public_path__ + "static/center-it-78234b0bdffb367976168f1bae21c4d5.webp";